import { Controller } from 'stimulus'
import Modal from 'bootstrap/js/src/modal'

export default class extends Controller {
  connect() {
    this.modal = $('#modal')

    this.modal.on('shown.bs.modal', () => {
      // Reconnect selectpickers
      const selectPickers = document.querySelectorAll('[data-controller="selectpicker"]')

      selectPickers.forEach(picker => {
        this.application.getControllerForElementAndIdentifier(picker, 'selectpicker').connect()
      }, this)
    })
  }

  show() {
    this.modal.modal()
  }

  hide() {
    this.modal.modal('hide')
  }

  hideOnSuccess({ detail: { success, fetchResponse } }) {
    if (success) {
      this.hide()

      // Follow the redirect to refresh the page
      if (fetchResponse?.response?.redirected) {
        Turbo.visit(fetchResponse.response.url, { action: 'replace' })
      }
    }
  }
}
